/* Mensa cart drawer — "Pairs well with" (Shopify product recommendations: complementary → related fallback) with quick add.
   Rendered inside the cart drawer; re-initialises after every drawer re-render (section rendering). Calm: no timers, no urgency. */
(function () {
  if (customElements.get('mv-cart-pairs')) return;
  var cache = {};
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur, currencyDisplay: cur === 'USD' ? 'symbol' : 'narrowSymbol' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function img(url, w) { if (!url) return ''; url = url.indexOf('//') === 0 ? 'https:' + url : url; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function esc(s) { return String(s || '').replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function getRecs(pid, intent) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent)
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return j.products || []; })
      .catch(function () { return []; });
  }
  class MvCartPairs extends HTMLElement {
    connectedCallback() {
      var pid = this.dataset.productId; if (!pid) return;
      var exclude = (this.dataset.exclude || '').split(',');
      var limit = parseInt(this.dataset.limit || '3', 10);
      var key = pid + '|' + this.dataset.exclude;
      var self = this;
      if (cache[key]) { this.render(cache[key]); return; }
      getRecs(pid, 'complementary').then(function (list) {
        var pick = function (arr) { return arr.filter(function (p) { return p.available && exclude.indexOf(String(p.id)) === -1; }); };
        var out = pick(list);
        if (out.length) return out;
        return getRecs(pid, 'related').then(pick);
      }).then(function (list) {
        cache[key] = list.slice(0, limit);
        self.render(cache[key]);
      });
    }
    render(list) {
      if (!list || !list.length) { this.hidden = true; return; }
      var rows = list.map(function (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        var control;
        if (avail.length === 1) {
          control = '<button type="button" class="mv-pairs__add" data-variant="' + avail[0].id + '" aria-label="Add ' + esc(p.title) + ' to cart">Add</button>';
        } else {
          control = '<label class="mv-pairs__pick"><span class="visually-hidden">Choose an option to add ' + esc(p.title) + '</span>' +
            '<select class="mv-pairs__select" aria-label="Choose an option to add ' + esc(p.title) + '"><option value="" selected disabled>Add +</option>' +
            avail.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select></label>';
        }
        return '<li class="mv-pairs__item">' +
          '<a class="mv-pairs__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' + (p.featured_image ? '<img src="' + img(p.featured_image, 120) + '" alt="" width="48" height="60" loading="lazy">' : '') + '</a>' +
          '<div class="mv-pairs__info"><a class="mv-pairs__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="mv-pairs__price">' + money(p.price) + '</span></div>' +
          control + '</li>';
      }).join('');
      this.innerHTML = '<p class="mv-pairs__heading">Pairs well with</p><ul class="mv-pairs__list" role="list">' + rows + '</ul><p class="mv-pairs__error" role="alert" hidden></p>';
      this.hidden = false;
      var self = this;
      this.querySelectorAll('.mv-pairs__add').forEach(function (b) { b.addEventListener('click', function () { self.add(b.dataset.variant, b); }); });
      this.querySelectorAll('.mv-pairs__select').forEach(function (s) { s.addEventListener('change', function () { if (s.value) self.add(s.value, s); }); });
    }
    add(variantId, el) {
      var self = this;
      el.disabled = true; el.closest('.mv-pairs__item').classList.add('is-adding');
      var drawer = document.querySelector('cart-drawer');
      var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sections.join(','), sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); }).then(function (res) {
        if (res.status) { throw new Error(res.description || res.message || 'Could not add this item.'); }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mv-cart-pairs', cartData: res });
        if (drawer && res.sections) drawer.renderContents(res); else window.location.href = root + 'cart';
      }).catch(function (e) {
        el.disabled = false; el.closest('.mv-pairs__item').classList.remove('is-adding');
        var err = self.querySelector('.mv-pairs__error'); if (err) { err.textContent = e.message; err.hidden = false; }
      });
    }
  }
  customElements.define('mv-cart-pairs', MvCartPairs);
})();
